/**
 * Interfaz para recompras
 * Migrada desde api.service.ts (antes AppSync/GraphQL)
 */
export interface IRepurchase {
  uid: string;
  promotion_snapshot?: string | null;
  repurchase_amount?: number | null;
  waiverImageURL?: string | null;
  paymentImageURL?: string | null;
  created_at?: string | null;
  updated_at?: string | null;
  isLatest?: boolean | null;
}

/**
 * Interfaz para la respuesta de lista de recompras
 */
export interface IRepurchaseListResponse {
  items?: (IRepurchase | null)[] | null;
  nextToken?: string | null;
}
